import { h, defineComponent, VNodeChildren } from 'vue';
// @ts-ignore
import { BMessage } from 'buefy/dist/esm/message';

type MessageType = 'error' | 'warning' | 'info' | 'success';

export interface MessageProps {
  type: MessageType;
}

const decodeType = (msgType: MessageType): string => {
  const x: Record<string, string> = {
    success: 'is-success',
    error: 'is-danger',
    warning: 'is-warning',
    info: 'is-info',
  };
  return x[msgType] || 'is-info';
};

export const Message = defineComponent<MessageProps>({
  name: 'Message',
  props: ['type'],
  setup(props, context) {
    return function render() {
      return h(
        BMessage,
        { props: { type: decodeType(props.type) } },
        context.slots.default?.(),
      );
    };
  },
});

export const message = (type: MessageType, content: VNodeChildren, cssClass?: string) => h(
  Message,
  {
    class: cssClass,
    props: { type },
  },
  content,
);
